'use client';
import { buildTirageTable } from '@/helpers/tirageEnCourHelper';
import { useEffect, useState } from 'react';

const Table = ({ columnSize, tour, model }) => {
  const [isActiveTour, setIsActiveTour] = useState(false);
  const setLgColumnSize = (columnSize) => {
    const intColumnSize = parseInt(columnSize);
    switch (intColumnSize) {
      case 1:
        return 12;
      case 2:
        return 6;
      case 3:
        return 4;
      case 4:
        return 6;
      case 5:
        return 4;
      case 6:
        return 4;
      default:
        return 6;
    }
  };
  const setXlColumnSize = (columnSize) => {
    const intColumnSize = parseInt(columnSize);
    switch (intColumnSize) {
      case 1:
        return 12;
      case 2:
        return 6;
      case 3:
        return 4;
      case 4:
        return 3;
      case 5:
        return 2;
      case 6:
        return 2;
      default:
        return 6;
    }
  };
  const updateCartePleinneMessage = (cartePleineMessage, model) => {
    const originalMessage = cartePleineMessage;
    // find and replace `[cumulatif]` with : model.cumulatif.prix.toString()$
    const cumulatif = model?.cumulatif?.prix?.toString();
    const updatedMessage = cumulatif
      ? originalMessage.replace(/\[cumulatif\]/g, cumulatif + '$')
      : originalMessage;
    return updatedMessage;
  };

  useEffect(() => {
    const calculatedIsActiveTour =
      tour?.number === model?.tirage?.sequenceActif;
    setIsActiveTour(calculatedIsActiveTour);
  }, [tour, model]);

  return (
    <div
      className={`col-12 col-md-6 col-lg-${setLgColumnSize(
        columnSize
      )} col-xl-${setXlColumnSize(columnSize)} border border-dark maxh-100 bg-${
        isActiveTour ? tour.color : 'secondary-subtle'
      }`}
    >
      <div
        className={`title bg-${
          !isActiveTour ? tour.color : tour.color + ' secondary-subtle_bak'
        } border border-dark w-100 p-1 text-center fw-bold`}
      >
        JEU {tour.number}
      </div>
      <div className="games max-h-90 p-1 d-block d-md-flex flex-column justify-content-center">
        {tour.games.map((game, index) => (
          <div
            className={`game text-center  ${isActiveTour ? 'text-dark' : ''} ${
              game.gagnantActif ? 'text-decoration-line-through' : ''
            }`}
            key={index}
          >
            {game.name}
            {game.moitieMoitie && ' Moitié-Moitié'}
            &nbsp;
            {game?.cartePleineMessage ? (
              <span
                className=""
                dangerouslySetInnerHTML={{
                  __html: updateCartePleinneMessage(
                    game.cartePleineMessage,
                    model
                  ),
                }}
              />
            ) : game.prix ? (
              <span className="text-primary fw-bold">{game.prix}$</span>
            ) : null}
          </div>
        ))}
      </div>
    </div>
  );
};

const TirageTable = ({
  tirage,
  model,
  messages,
  lines = 2,
  /* eslint-disable */
  // Need to find a way to not use useState here
  tirageState = useState(buildTirageTable(tirage, model, messages)),
}) => {
  const [tirageTable, setTirageTable] = tirageState;
  const [firstHalfTirages, setFirstHalfTirages] = useState([]);
  const [secondHalfTirages, setSecondHalfTirages] = useState([]);

  const [dividedTirages, setDividedTirage] = useState([]);

  const [columnSize, setColumnSize] = useState('auto');

  useEffect(() => {
    const tirageTable = buildTirageTable(tirage, model);
    const columnSize = tirageTable.length;
    const half = Math.ceil(tirageTable.length / lines);

    const tmpDividedTirages = [];
    for (let i = 0; i < tirageTable.length; i += half) {
      tmpDividedTirages.push(tirageTable.slice(i, i + half));
    }
    setDividedTirage(tmpDividedTirages);

    const firstHalfTirages = tirageTable.slice(0, half);
    const secondHalfTirages = tirageTable.slice(half);

    setColumnSize(columnSize.toString());

    setFirstHalfTirages(firstHalfTirages);
    setSecondHalfTirages(secondHalfTirages);

    setTirageTable(tirageTable);
  }, [tirage]);

  return (
    <>
      <div className="row justify-content-center g-0">
        {dividedTirages.map((tirages, index) =>
          tirages.map((tour, index) => (
            <Table
              columnSize={columnSize}
              tour={tour}
              key={index}
              model={model}
            />
          ))
        )}
      </div>
    </>
  );
};

export default TirageTable;
